module.exports = __webpack_public_path__ + "static/media/tick_speech_bubble.43771dfe.svg";